var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cc-form-box',{attrs:{"form-type":_vm.formType},on:{"add":_vm.onAdd,"edit":_vm.onEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }